import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { allComponents } from './all.exports';


@NgModule({
  declarations: [
    ...allComponents 

  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports: [
    ...allComponents 

  ]
})
export class SearchFilterModule { }
